import { useEffect, useState } from 'react';

import type { Nullish } from '~/types/generics';

const useImageLoaded = (src: Nullish<string>) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false);

    if (!src) {
      return;
    }

    const handleLoad = () => {
      setIsLoaded(true);
    };

    const img = new Image();
    img.addEventListener('load', handleLoad);
    img.src = src;

    return () => {
      img.removeEventListener('load', handleLoad);
    };
  }, [src]);

  return isLoaded;
};

export default useImageLoaded;
